angular.module("harriApp").run(["$templateCache", function($templateCache) {
  $templateCache.put("../modules/hforms/basic_info/views/basic_info_form.html",
    "<form class=\"hform basic-info-form\" novalidate>\n" +
    "    <div class=\"form-line row\">\n" +
    "        <div class=\"field-text field col-sm-6\" ng-messages=\"form.validator.validation.phone.errors\">\n" +
    "            <label class=\"field-label\" for=\"basic_info_mobile\">{{\"Mobile Phone\" | translate}}</label>\n" +
    "            <input\n" +
    "                name=\"phone\"\n" +
    "                type=\"tel\"\n" +
    "                id=\"basic_info_mobile\"\n" +
    "                ng-model=\"form.data.phone\"\n" +
    "                validate-rule=\"required|phoneNumber\"\n" +
    "                h-intl-tel-input=\"{validate:true}\"\n" +
    "            />\n" +
    "            <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Mobile phone is required\" | translate }}</div>\n" +
    "            <div role=\"alert\" ng-message=\"phoneNumber\" class=\"error\">{{ \"Please enter a valid phone number\" | translate }}</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
  $templateCache.put("../modules/hforms/availability_matrix/views/availability_matrix_form.html",
    "<form class=\"hform availability-matrix-form\" novalidate\n" +
    "      role=\"form\"\n" +
    "      aria-label=\"{{'Select your week availability (Required)'|translate}}\">\n" +
    "    <div class=\"form-line row\">\n" +
    "        <div class=\"field-text field col-sm-12\" ng-messages=\"form.validator.validation['availability-matrix'].errors\">\n" +
    "            <div validate-rule=\"required_matrix\"\n" +
    "                 validate-target=\"input[name='availability-matrix']\">\n" +
    "                <table class=\"availability-matrix-table table horizontal-table mb-0\">\n" +
    "                    <tr>\n" +
    "                        <th class=\"text-center\">\n" +
    "                            <div class=\"week-day-header\">{{'Availability survey' | translate}}</div>\n" +
    "                        </th>\n" +
    "                        <th class=\"week-day text-center\">\n" +
    "                            <div class=\"week-day-header\">{{ form.moment().isoWeekday(1).format(\"ddd\") }}</div>\n" +
    "                            <div ng-if=\"form.data.matrix['MON'].is_morning && form.data.matrix['MON'].is_evening\"\n" +
    "                                 class=\"capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </th>\n" +
    "                        <th class=\"week-day text-center\">\n" +
    "                            <div class=\"week-day-header\">{{ form.moment().isoWeekday(2).format(\"ddd\") }}</div>\n" +
    "                            <div ng-if=\"form.data.matrix['TUE'].is_morning && form.data.matrix['TUE'].is_evening\"\n" +
    "                                 class=\"capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </th>\n" +
    "                        <th class=\"week-day text-center\">\n" +
    "                            <div class=\"week-day-header\">{{ form.moment().isoWeekday(3).format(\"ddd\") }}</div>\n" +
    "                            <div ng-if=\"form.data.matrix['WED'].is_morning && form.data.matrix['WED'].is_evening\"\n" +
    "                                 class=\"capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </th>\n" +
    "                        <th class=\"week-day text-center\">\n" +
    "                            <div class=\"week-day-header\">{{ form.moment().isoWeekday(4).format(\"ddd\") }}</div>\n" +
    "                            <div ng-if=\"form.data.matrix['THU'].is_morning && form.data.matrix['THU'].is_evening\"\n" +
    "                                 class=\"capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </th>\n" +
    "                        <th class=\"week-day text-center\">\n" +
    "                            <div class=\"week-day-header\">{{ form.moment().isoWeekday(5).format(\"ddd\") }}</div>\n" +
    "                            <div ng-if=\"form.data.matrix['FRI'].is_morning && form.data.matrix['FRI'].is_evening\"\n" +
    "                                 class=\"capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </th>\n" +
    "                        <th class=\"week-day text-center\">\n" +
    "                            <div class=\"week-day-header\">{{ form.moment().isoWeekday(6).format(\"ddd\") }}</div>\n" +
    "                            <div ng-if=\"form.data.matrix['SAT'].is_morning && form.data.matrix['SAT'].is_evening\"\n" +
    "                                 class=\"capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </th>\n" +
    "                        <th class=\"week-day text-center\">\n" +
    "                            <div class=\"week-day-header\">{{ form.moment().isoWeekday(7).format(\"ddd\") }}</div>\n" +
    "                            <div ng-if=\"form.data.matrix['SUN'].is_morning && form.data.matrix['SUN'].is_evening\"\n" +
    "                                 class=\"capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </th>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"week-day-row\">\n" +
    "                        <td class=\"row-title semi-bold text-center\">\n" +
    "                            <div class=\"semi-bold\">{{'Morning' | translate}}</div>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Monday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['MON'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Tuesday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['TUE'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'wednesday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['WED'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'thursday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['THU'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Friday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['FRI'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Saturday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['SAT'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Sunday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['SUN'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"week-day-row\">\n" +
    "                        <td class=\"row-title semi-bold text-center\">\n" +
    "                            <div class=\"semi-bold\">{{'Evening' | translate}}</div>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" off-icon=\"check-circle\" theme=\"active-blue\"\n" +
    "                                        on-icon=\"check-circle\" name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Monday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['MON'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Tuesday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['TUE'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'wednesday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['WED'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'thursday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['THU'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'friday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['FRI'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'saturday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['SAT'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'sunday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['SUN'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "\n" +
    "                <table class=\"availability-matrix-table table vertical-table mb-0\">\n" +
    "                    <tr>\n" +
    "                        <th class=\"text-center\">\n" +
    "                            <div class=\"week-day-header\">{{'Availability survey' | translate}}</div>\n" +
    "                        </th>\n" +
    "                        <th class=\"row-title semi-bold text-center\">\n" +
    "                            <div class=\"semi-bold\">{{'Morning' | translate}}</div>\n" +
    "                        </th>\n" +
    "                        <th class=\"row-title semi-bold text-center\">\n" +
    "                            <div class=\"semi-bold\">{{'Evening' | translate}}</div>\n" +
    "                        </th>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"week-day-row\">\n" +
    "                        <td class=\"week-day\">\n" +
    "                            <div class=\"week-day-header\">Mon</div>\n" +
    "                            <div ng-if=\"form.data.matrix['MON'].is_morning && form.data.matrix['MON'].is_evening\"\n" +
    "                                 class=\"all-day capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Monday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['MON'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Monday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['MON'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"week-day-row\">\n" +
    "                        <td class=\"week-day\">\n" +
    "                            <div class=\"week-day-header\">Tue</div>\n" +
    "                            <div ng-if=\"form.data.matrix['TUE'].is_morning && form.data.matrix['TUE'].is_evening\"\n" +
    "                                 class=\"all-day capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Tuesday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['TUE'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Tuesday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['TUE'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"week-day-row\">\n" +
    "                        <td class=\"week-day\">\n" +
    "                            <div class=\"week-day-header\">Wed</div>\n" +
    "                            <div ng-if=\"form.data.matrix['WED'].is_morning && form.data.matrix['WED'].is_evening\"\n" +
    "                                 class=\"all-day capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'wednesday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['WED'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'wednesday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['WED'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"week-day-row\">\n" +
    "                        <td class=\"week-day\">\n" +
    "                            <div class=\"week-day-header\">Thu</div>\n" +
    "                            <div ng-if=\"form.data.matrix['THU'].is_morning && form.data.matrix['THU'].is_evening\"\n" +
    "                                 class=\"all-day capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Thursday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['THU'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Thursday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['THU'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"week-day-row\">\n" +
    "                        <td class=\"week-day\">\n" +
    "                            <div class=\"week-day-header\">Fri</div>\n" +
    "                            <div ng-if=\"form.data.matrix['FRI'].is_morning && form.data.matrix['FRI'].is_evening\"\n" +
    "                                 class=\"all-day capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Friday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['FRI'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Friday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['FRI'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"week-day-row\">\n" +
    "                        <td class=\"week-day\">\n" +
    "                            <div class=\"week-day-header\">Sat</div>\n" +
    "                            <div ng-if=\"form.data.matrix['SAT'].is_morning && form.data.matrix['SAT'].is_evening\"\n" +
    "                                 class=\"all-day capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Saturday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['SAT'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Saturday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['SAT'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                    <tr class=\"week-day-row\">\n" +
    "                        <td class=\"week-day\">\n" +
    "                            <div class=\"week-day-header\">Sun</div>\n" +
    "                            <div ng-if=\"form.data.matrix['SUN'].is_morning && form.data.matrix['SUN'].is_evening\"\n" +
    "                                 class=\"all-day capitalize text-primary small\">{{'all day' | translate}}\n" +
    "                            </div>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Sunday Morning'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['SUN'].is_morning\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                        <td class=\"checkbox-cell text-center p-0\">\n" +
    "                            <h-checkbox off-icon=\"check-circle\" theme=\"active-blue\" on-icon=\"check-circle\"\n" +
    "                                        name=\"availability-matrix\"\n" +
    "                                        h-aria-label=\"{{'Sunday Evening'|translate}}\"\n" +
    "                                        ng-model=\"form.data.matrix['SUN'].is_evening\"></h-checkbox>\n" +
    "                        </td>\n" +
    "                    </tr>\n" +
    "                </table>\n" +
    "            </div>\n" +
    "            <div role=\"alert\" ng-message=\"required_matrix\"\n" +
    "                 class=\"error\">{{ \"Please indicate your week availability\" | translate }}</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
  $templateCache.put("../modules/hforms/resume_upload/views/resume_upload_form.html",
    "<form class=\"hform resume-upload-form\" novalidate\n" +
    "      role=\"form\" aria-labelledby=\"resume_upload_label\">\n" +
    "    <div class=\"form-line row text-center\" ng-messages=\"form.validator.validation['resume-upload'].errors\">\n" +
    "        <input type=\"hidden\"\n" +
    "               validate-rule=\"required_files\"\n" +
    "               name=\"resume-upload\"/>\n" +
    "        <div ng-attr-id=\"resume_upload_label\" ng-if=\"!form.data.files[0].name\" class=\"col-12 text-left section-title\">\n" +
    "            {{'Upload your' | translate}} {{form.jobLocation | getResumeLocalized | translate}}\n" +
    "            <span ng-show=\"!form.required\"\n" +
    "                  class=\"semi-bold\">({{ 'Optional' | translate }})</span>\n" +
    "        </div>\n" +
    "        <div ng-attr-id=\"resume_upload_label\" ng-if=\"form.data.files[0].name\" class=\"col-12 text-left section-title\">\n" +
    "            {{'Your attached' | translate}} {{form.jobLocation | getResumeLocalized | translate}}\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-12\"\n" +
    "             ng-if=\"!form.data.files[0].name\">\n" +
    "            <div class=\"flex-column align-items-center upload-container upload-doc-web\"\n" +
    "                 id=\"resume-preview\"\n" +
    "                 name=\"resume\"\n" +
    "                 ngf-drop=\"form.onFileSelect($files)\"\n" +
    "                 ngf-drop-available=\"dropSupported=true\"\n" +
    "                 ngf-drag-over-class=\"dragOverClass($event)\">\n" +
    "\n" +
    "                <div class=\"upload-icon-container\"><i class=\"fa fa-cloud-upload\"></i></div>\n" +
    "                <div class=\"placeholder-text w-25\">{{ 'Drag and drop files here or' | translate }}</div>\n" +
    "                <div ng-show=\"form.fill_user_profile\"\n" +
    "                     class=\"placeholder-text mt-2\">{{ 'Will Make Your Profile Awesome' | translate }}</div>\n" +
    "\n" +
    "                <!-- upload button -->\n" +
    "                <button accept=\".pdf,.doc,.docx,.txt,.rtf\"\n" +
    "                        ngf-select=\"form.onFileSelect($files)\"\n" +
    "                        ng-disabled=\"form.profile_resume_progress === 'IN_PROGRESS'\"\n" +
    "                        onclick=\"this.value = null\"\n" +
    "                        class=\"btn h-md-blue-outline-btn mt-2\">\n" +
    "                    {{'Upload' | translate}} {{ form.jobLocation | getResumeLocalized}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "            <div class=\"upload-doc-mobile\">\n" +
    "                <button accept=\".pdf,.doc,.docx,.txt,.rtf\"\n" +
    "                        ngf-select=\"form.onFileSelect($files)\"\n" +
    "                        ng-disabled=\"form.profile_resume_progress === 'IN_PROGRESS'\"\n" +
    "                        onclick=\"this.value = null\"\n" +
    "                        class=\"btn h-md-blue-outline-btn w-100\">\n" +
    "                    {{'Upload' | translate}} {{ form.jobLocation | getResumeLocalized}}\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-12\"\n" +
    "             ng-if=\"form.data.files[0].name || form.profile_resume_progress  === 'IN_PROGRESS'\">\n" +
    "            <div class=\"uploaded-view with-bg-color p-4\">\n" +
    "                <div class=\"row\">\n" +
    "                    <div class=\"col-12 col-md-7 doc-file text-left\">\n" +
    "                        <div class=\"row\">\n" +
    "                            <div class=\"col-12 col-md-2 file-icon text-center\">\n" +
    "                                <i class=\"fa fa-file-text-o\"></i>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-12 col-md-10 text-muted doc-name\">\n" +
    "                                <div><i class=\"fa fa-spinner fa-spin blue\"\n" +
    "                                        ng-show=\"form.profile_resume_progress  === 'IN_PROGRESS'\"></i> {{form.data.files[0].name}}</div>\n" +
    "                            </div>\n" +
    "                            <div class=\"col-12 col-md-10 col-sm-offset-2 offset-sm-2\">\n" +
    "                                <div ng-if=\"form.profile_resume_progress === 'IN_PROGRESS'\"\n" +
    "                                     class=\"progress h-progress-1\">\n" +
    "                                    <div class=\"progress-bar\" role=\"progressbar\"\n" +
    "                                         aria-valuenow=\"{{form.resume_progress}}\" aria-valuemin=\"0\"\n" +
    "                                         aria-valuemax=\"100\" ng-style=\"{ 'width': form.resume_progress + '%' }\">\n" +
    "                                    </div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-12 col-md-5\">\n" +
    "                        <a ng-if=\"form.data.files[0].href && form.data.files[0].needs_assign\"\n" +
    "                           class=\"btn h-md-blue-outline-btn full-width\"\n" +
    "                           target=\"_blank\"\n" +
    "                           ng-href=\"{{[form.data.files[0].href] | hResumeURL: form.data.files[0].extension: true}}\"\n" +
    "                           ng-disabled=\"form.profile_resume_progress === 'IN_PROGRESS'\">\n" +
    "                            {{'View' | translate}}\n" +
    "                        </a>\n" +
    "                        <div class=\"space-xs d-block d-sm-none\"></div>\n" +
    "                        <div class=\"drop-upload\">\n" +
    "                            <button accept=\".pdf,.doc,.docx,.txt,.rtf\"\n" +
    "                                 ngf-select=\"form.onFileSelect($files, true)\"\n" +
    "                                 ng-disabled=\"form.profile_resume_progress === 'IN_PROGRESS'\"\n" +
    "                                 onclick=\"this.value = null\"\n" +
    "                                 data-trigger=\"hover\"\n" +
    "                                 data-title=\"{{'Upload New' | translate}}\"\n" +
    "                                 data-container=\".resume-buttons\"\n" +
    "                                 class=\"btn btn h-md-blue-outline-btn full-width cut-text\">\n" +
    "                                <span class=\"upload-button-text\">\n" +
    "                                    <i class=\"fa fa-upload d-none d-sm-inline\"></i> {{'Upload New' | translate}}\n" +
    "                                </span>\n" +
    "                            </button>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"col-12\">\n" +
    "            <div role=\"alert\" ng-message=\"required_files\" class=\"error\">{{ \"Please select your\" | translate }} {{ form.jobLocation | getResumeLocalized}}</div>\n" +
    "            <div role=\"alert\" ng-if=\"form.resume_upload_error_message\" class=\"error\">{{form.resume_upload_error_message}}</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "</form>\n" +
    "");
  $templateCache.put("../modules/hforms/experience/views/experience_form.html",
    "<form class=\"hform experience-form\">\n" +
    "    <div ng-if=\"!form.isJobApplicationForm()\">\n" +
    "        <div id=\"experience_{{$index}}\" ng-repeat=\"experience in form.data.experience track by $index\">\n" +
    "            <div class=\"form-line row\">\n" +
    "                <div class=\"field-select-2 field col-12\">\n" +
    "                    <div ng-if=\"$index >= 1\">\n" +
    "                        <div class=\"sep-gray-8 float-none\"></div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div ng-if=\"$index == 0\">\n" +
    "                        <div class=\"heading-1 brand-settings-sub-title\">{{'Where do you currently work?' | translate}}</div>\n" +
    "                        <div class=\"h-text small gray\"\n" +
    "                             ng-show=\"form.isSettingsForm()\">{{'if you’re looking right now, please tell us the last place you worked' | translate}}</div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div ng-if=\"$index >= 1\">\n" +
    "                        <div class=\"h-text md light blue\">{{'Where else have you worked?' | translate}}</div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <label\n" +
    "                        ng-if=\"!form.isSettingsForm() && !form.data.firstJob && experience.brand\">{{\"Employer\" | translate}}</label>\n" +
    "                    <div ng-if=\"!form.data.firstJob\">\n" +
    "                        <div ng-messages=\"form.validator.validation['employer' + $index].errors\">\n" +
    "                            <div class=\"harri-select2\"\n" +
    "                                 validate-rule=\"required\"\n" +
    "                                 validate-index=\"{{$index}}\"\n" +
    "                                 validate-target=\"input[name='employer']\">\n" +
    "                                <h-select fullwidth=\"true\"\n" +
    "                                          placeholder=\"Enter a company name and/or address...\"\n" +
    "                                          h-name=\"employer\"\n" +
    "                                          h-model=\"experience.brand\"\n" +
    "                                          h-options=\"brand as brand.label for brand in serverGoogleBrandSearch($searchValue)\"\n" +
    "                                          new-entry-placeholder=\"{{'Can\\'t find what you’re looking for? Keep typing to create your own entry' | translate}}\"\n" +
    "                                          minimum-input-length=\"3\"\n" +
    "                                          allow-new-entry=\"brand_name\"\n" +
    "                                          h-no-filteration=\"true\"\n" +
    "                                          server-google-brand-search\n" +
    "                                          powered-by-google=\"true\"\n" +
    "                                          allow-clear=\"true\"\n" +
    "                                          on-clear-call=\"form.deleteExperience( $index )\"\n" +
    "                                >\n" +
    "                                </h-select>\n" +
    "                                <div ng-if=\"!form.isSettingsForm()\" role=\"alert\" ng-message=\"required\"\n" +
    "                                     class=\"error\">{{ \"Please select employer\" | translate }}</div>\n" +
    "                                <div ng-if=\"form.isSettingsForm()\" role=\"alert\" ng-message=\"required\"\n" +
    "                                     class=\"error\">{{ \"Work history can't be empty\" | translate }}</div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"text-left\"\n" +
    "                         ng-hide=\"!form.data.firstJob && (form.data.experience[0].brand || form.data.experience.length >= 2)\">\n" +
    "                        <h-checkbox name=\"first_job\"\n" +
    "                                    class=\"active-blue\"\n" +
    "                                    id=\"first_job\"\n" +
    "                                    ng-model=\"form.data.firstJob\"\n" +
    "                                    h-aria-label=\"{{ 'I have no experience, this is my first job' | translate }}\"\n" +
    "                                    label=\"{{ 'I have no experience, this is my first job' | translate }}\"\n" +
    "                                    ng-change=\"form.deleteExperience\">\n" +
    "                        </h-checkbox>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"experience\" ng-if=\"!form.data.firstJob && experience.brand\">\n" +
    "                <div class=\"form-line row\" ng-if=\"experience.brand.brand_name\">\n" +
    "                    <div class=\"field-select-2 field col-12\">\n" +
    "                        <label>{{\"Address\" | translate}}</label>\n" +
    "                        <div validate-rule=\"no-validation\"\n" +
    "                             validate-index=\"{{$index}}\"\n" +
    "                             validate-target=\"input[name='google_location']\">\n" +
    "                            <h-select fullwidth=\"true\"\n" +
    "                                      name=\"google_location\"\n" +
    "                                      placeholder=\"Enter address...\"\n" +
    "                                      h-model=\"experience.google_location\"\n" +
    "                                      h-options=\"address.value as address.label for address in getAddress($searchValue)\"\n" +
    "                                      minimum-input-length=\"3\"\n" +
    "                                      h-no-filteration=\"true\"\n" +
    "                                      google-autocomplete\n" +
    "                                      powered-by-google=\"true\">\n" +
    "                            </h-select>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row\">\n" +
    "                    <div class=\"field-select-2 field col-12\">\n" +
    "                        <label ng-show=\"!form.isSettingsForm()\">{{\"Job title\" | translate}}</label>\n" +
    "                        <label ng-show=\"form.isSettingsForm()\">{{\"Position\" | translate}}</label>\n" +
    "                        <div ng-messages=\"form.validator.validation['position_id' + $index].errors\">\n" +
    "                            <div\n" +
    "                                validate-rule=\"{{form.isCutsomPosition[$index] !== true ? 'required' : 'no-validation'}}\"\n" +
    "                                validate-index=\"{{$index}}\"\n" +
    "                                validate-target=\"input[name='position_id']\">\n" +
    "                                <h-select-list\n" +
    "                                    name=\"position_id\"\n" +
    "                                    placeholder=\"What Position did you hold?\"\n" +
    "                                    item-key=\"id\"\n" +
    "                                    text-key=\"name\"\n" +
    "                                    ng-model=\"experience.position\"\n" +
    "                                    ng-disabled=\"form.isCutsomPosition[$index] == true\"\n" +
    "                                    items=\"form.data.positions\"\n" +
    "                                    multi=\"false\">\n" +
    "                                </h-select-list>\n" +
    "                                <div ng-if=\"!form.isSettingsForm()\" role=\"alert\" ng-message=\"required\"\n" +
    "                                     class=\"error\">{{ \"Please select job title\" | translate }}</div>\n" +
    "                                <div ng-if=\"form.isSettingsForm()\" role=\"alert\" ng-message=\"required\"\n" +
    "                                     class=\"error\">{{ \"Position can't be empty\" | translate }}</div>\n" +
    "                                <div class=\"pl-1 col-12\">\n" +
    "                                    {{ \"Can’t find what you’re looking for\" | translate }}? <a\n" +
    "                                    ng-click=\"form.addCustomPosition($index)\"\n" +
    "                                    ng-href=\"{{ 'javascript:' | trusted }}\">{{ \"click here\" | translate }}</a>.\n" +
    "                                </div>\n" +
    "                                <div class=\"col-12 px-0\"\n" +
    "                                     ng-if=\"form.isCutsomPosition[$index] == true\"\n" +
    "                                     ng-messages=\"form.validator.validation['custom_position' + $index].errors\">\n" +
    "                                    <div class=\"d-flex align-items-center\">\n" +
    "                                        <div>\n" +
    "                                            <button type=\"button\"\n" +
    "                                                    ng-click=\"form.closeCustomPosition($index)\"\n" +
    "                                                    class=\"btn btn-lg p-2\">\n" +
    "                                                <i class=\"fa fa-times blue\"></i>\n" +
    "                                            </button>\n" +
    "                                        </div>\n" +
    "                                        <div class=\"field ml-2 w-100\">\n" +
    "                                            <input type=\"text\"\n" +
    "                                                   validate-index=\"{{$index}}\"\n" +
    "                                                   validate-rule=\"required\"\n" +
    "                                                   name=\"custom_position\"\n" +
    "                                                   ng-model=\"experience.position.custom_position\"/>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                    <div ng-if=\"!form.isSettingsForm()\" role=\"alert\" ng-message=\"required\"\n" +
    "                                         class=\"error\">{{ \"Please select job title\" | translate }}</div>\n" +
    "                                    <div ng-if=\"form.isSettingsForm()\" role=\"alert\" ng-message=\"required\"\n" +
    "                                         class=\"error\">{{ \"Position can't be empty\" | translate }}</div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row\"\n" +
    "                     ng-if=\"!form.isSettingsForm()\">\n" +
    "                    <div class=\"field-text field col-sm-5\"\n" +
    "                         ng-messages=\"form.validator.validation['phone' + $index].errors\">\n" +
    "                        <label>{{\"Phone\" | translate}}</label>\n" +
    "                        <input name=\"phone\"\n" +
    "                               type=\"tel\"\n" +
    "                               validate-rule=\"phone\"\n" +
    "                               validate-index=\"{{$index}}\"\n" +
    "                               ng-model=\"experience.phone\"/>\n" +
    "                        <div role=\"alert\" ng-message=\"phone\" class=\"error\">{{ \"Invalid phone\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row\"\n" +
    "                     ng-if=\"!form.isSettingsForm()\">\n" +
    "                    <div class=\"field-text field col-sm-5\">\n" +
    "                        <label>{{\"Supervisor/Title\" | translate}}</label>\n" +
    "                        <input type=\"text\" name=\"supervisor\" ng-model=\"experience.supervisor\"/>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row\">\n" +
    "                    <div class=\"field-month field col-6\"\n" +
    "                         ng-messages=\"form.validator.validation['start_date' + $index].errors\">\n" +
    "                        <label tabindex=\"0\" class=\"control-label\">{{'Start date' | translate}}</label>\n" +
    "                        <div validate-rule=\"required_if:end_date|date_range\"\n" +
    "                             validate-index=\"{{$index}}\"\n" +
    "                             validate-target=\"input[name='start_date']\">\n" +
    "                            <month-date-picker\n" +
    "                                optional-month=\"true\"\n" +
    "                                ng-model=\"experience.start_date\"\n" +
    "                                name=\"start_date\"\n" +
    "                                ng-required=\"true\"\n" +
    "                                container-prefix=\"work_start_date{{$index}}\"\n" +
    "                                update-end-date=\"true\"\n" +
    "                                end-date=\"experience.end_date\"\n" +
    "                            >\n" +
    "                            </month-date-picker>\n" +
    "                        </div>\n" +
    "                        <div role=\"alert\" ng-message=\"required_if\"\n" +
    "                             class=\"error\">{{ \"Please select start date\" | translate }}</div>\n" +
    "                        <div role=\"alert\" ng-message=\"date_range\"\n" +
    "                             class=\"error\">{{ \"Start date must be less than end date\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                    <div class=\"field-month field col-6\"\n" +
    "                         ng-messages=\"form.validator.validation['end_date' + $index].errors\">\n" +
    "                        <label tabindex=\"0\">{{'End date' | translate}}</label>\n" +
    "                        <div ng-if=\"!experience.still_work_here\"\n" +
    "                             validate-rule=\"required_if_not:still_work_here\"\n" +
    "                             validate-index=\"{{$index}}\"\n" +
    "                             validate-target=\"input[name='end_date']\"\n" +
    "                             validate-trigger=\"change:.experience:input[name='start_date']\">\n" +
    "                            <month-date-picker\n" +
    "                                ng-model=\"experience.end_date\"\n" +
    "                                container-selector=\"#work_end_date{{$index}}\"\n" +
    "                                name=\"end_date\"\n" +
    "                                ng-required=\"!experience.still_work_here\"\n" +
    "                                validate-end-date=\"false\"\n" +
    "                                start-date=\"experience.start_date\"\n" +
    "                            >\n" +
    "                            </month-date-picker>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"experience.still_work_here\">\n" +
    "                            <span class=\"gray italic\">{{'I am currently in this work'|translate}}</span>\n" +
    "                        </div>\n" +
    "                        <div role=\"alert\" ng-message=\"required_if_not\"\n" +
    "                             class=\"error\">{{ \"Please select end date\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row\">\n" +
    "                    <div id=\"still_work_here{{$index}}\" class=\"field-checkbox field col-12 offset-sm-6 col-sm-6\">\n" +
    "                        <div validate-trigger=\"change:.experience:input[name='end_date']\">\n" +
    "                            <checkbox3 name=\"still_work_here\"\n" +
    "                                       value=\"true\"\n" +
    "                                       label=\"{{'I am currently in this work' | translate}}\"\n" +
    "                                       ng-model=\"experience.still_work_here\"\n" +
    "                            >\n" +
    "                            </checkbox3>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row\"\n" +
    "                     ng-if=\"!form.isSettingsForm()\">\n" +
    "                    <div class=\"field-select field col-sm-5\">\n" +
    "                        <label>{{\"May we contact for a reference?\" | translate}}</label>\n" +
    "                        <div ng-messages=\"form.validator.validation['contact_reference' + $index].errors\">\n" +
    "                        <span class=\"select-wrapper\">\n" +
    "                          <select validate-rule=\"required\"\n" +
    "                                  validate-index=\"{{$index}}\"\n" +
    "                                  name=\"contact_reference\"\n" +
    "                                  ng-model=\"form.data.experience[$index].allow_to_contact_reference\"\n" +
    "                          >\n" +
    "                              <option class=\"hidden d-none\" disabled></option>\n" +
    "                              <option value=\"no\">{{\"No\" | translate}}</option>\n" +
    "                              <option value=\"yes\">{{\"Yes\" | translate}}</option>\n" +
    "                          </select>\n" +
    "                          <i class=\"fa fa-chevron-down\"></i>\n" +
    "                        </span>\n" +
    "                            <div role=\"alert\" ng-message=\"required\"\n" +
    "                                 class=\"error\">{{ \"Please answer this question\" | translate }}</div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row\"\n" +
    "                     ng-if=\"!form.isSettingsForm()\">\n" +
    "                    <div class=\"field-textarea field col-sm-9\">\n" +
    "                        <label>{{\"Reason for Leaving?\" | translate}}</label>\n" +
    "                        <textarea name=\"reason_for_leaving\" ng-model=\"experience.reason_for_leaving\"></textarea>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row\"\n" +
    "                     ng-if=\"form.isSettingsForm()\">\n" +
    "                    <div class=\"field-textarea field col-sm-12\">\n" +
    "                        <label>{{'Tell us briefly about your responsibilities at' | translate}} <span\n" +
    "                            ng-bind-html=\"experience.brand.brand_name || experience.brand.label\"></span></label>\n" +
    "                        <textarea name=\"description\" maxlength=\"64000\" ng-model=\"experience.description\"></textarea>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"form-line row\" ng-if=\"!form.data.firstJob && (form.data.experience[0].brand || $index > 0)\">\n" +
    "                <div class=\"col-12 action-group\">\n" +
    "                    <div class=\"field-button field\">\n" +
    "                        <button type=\"button\" ng-click=\"form.deleteExperience($index)\"\n" +
    "                                class=\"btn btn-outline-secondary\"><i\n" +
    "                            class=\"fa fa-minus-circle\"></i> {{'Remove' | translate}}</button>\n" +
    "                    </div>\n" +
    "                    <div class=\"field-button field\" ng-if=\"$last\">\n" +
    "                        <button type=\"button\" ng-click=\"form.addNewExperience()\" class=\"btn btn-outline-secondary full-screen-btn-mobile\">\n" +
    "                            <i class=\"fa fa-plus mr-1\"></i> {{'Add another employment history' | translate}}\n" +
    "                        </button>\n" +
    "                        &nbsp;\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"form.isJobApplicationForm()\">\n" +
    "        <div class=\"form-line row pb-3\">\n" +
    "            <div class=\"field-select-2 field col-12 py-0\">\n" +
    "                <div class=\"text-left\"\n" +
    "                     ng-messages=\"form.validator.validation['first_job'].errors\">\n" +
    "                    <div validate-rule=\"missing_required_fields\"\n" +
    "                         validate-target=\"input[name='first_job']\">\n" +
    "                        <h-checkbox name=\"first_job\"\n" +
    "                                    class=\"active-blue\"\n" +
    "                                    id=\"first_job\"\n" +
    "                                    ng-model=\"form.data.firstJob\"\n" +
    "                                    theme=\"active-blue\"\n" +
    "                                    on-icon=\"check-square\"\n" +
    "                                    ng-disabled=\"form.showExperience\"\n" +
    "                                    h-aria-label=\"{{ 'I have no experience, this is my first job' | translate }}\"\n" +
    "                                    label=\"{{ 'I have no experience, this is my first job' | translate }}\"\n" +
    "                                    on-change=\"form.toggleFirstJob()\">\n" +
    "                        </h-checkbox>\n" +
    "                        <div role=\"alert\" ng-message=\"missing_required_fields\"\n" +
    "                             class=\"error\">{{ \"Please check this box or click the button below\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div ng-repeat=\"experience in form.data.experience track by $index\" ng-if=\"form.showExperience\">\n" +
    "            <div class=\"p-4 mb-3 with-bg-color\">\n" +
    "                <div class=\"form-line row pb-3\">\n" +
    "                    <div class=\"col-12 d-flex justify-content-between align-items-center\">\n" +
    "                        <div class=\"section-item-label\">{{ \"Employment history\" | translate }} #{{$index + 1}}</div>\n" +
    "                        <button class=\"delete-btn border-0\" ng-click=\"form.deleteExperience($index)\">\n" +
    "                            <i class=\"fa fa-trash delete-icon\"></i>\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row pb-3\">\n" +
    "                    <div class=\"col-12\">\n" +
    "                        <div ng-if=\"$index >= 1\">\n" +
    "                            <hr>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <div ng-if=\"$index >= 1\">\n" +
    "                            <div class=\"h-text md light blue\">{{'Where else have you worked?' | translate}}</div>\n" +
    "                        </div>\n" +
    "\n" +
    "                        <label class=\"field-label\">{{\"Employer\" | translate}}</label>\n" +
    "                        <div ng-messages=\"form.validator.validation['employer' + $index].errors\">\n" +
    "                            <div class=\"field-select-2 field\"\n" +
    "                                 validate-rule=\"required\"\n" +
    "                                 validate-index=\"{{$index}}\"\n" +
    "                                 validate-target=\"input[name='employer']\">\n" +
    "                                <h-select fullwidth=\"true\"\n" +
    "                                          placeholder=\"Enter a company name and/or address...\"\n" +
    "                                          h-name=\"employer\"\n" +
    "                                          h-model=\"experience.brand\"\n" +
    "                                          h-options=\"brand as brand.label for brand in serverGoogleBrandSearch($searchValue)\"\n" +
    "                                          new-entry-placeholder=\"{{'Can\\'t find what you’re looking for? Keep typing to create your own entry' | translate}}\"\n" +
    "                                          minimum-input-length=\"3\"\n" +
    "                                          allow-new-entry=\"brand_name\"\n" +
    "                                          h-no-filteration=\"true\"\n" +
    "                                          server-google-brand-search\n" +
    "                                          powered-by-google=\"true\"\n" +
    "                                          allow-clear=\"true\"\n" +
    "                                          on-clear-call=\"form.deleteExperience($index)\">\n" +
    "                                </h-select>\n" +
    "                                <div role=\"alert\" ng-message=\"required\"\n" +
    "                                     class=\"error\">{{ \"Please select employer\" | translate }}</div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row pb-2\" ng-if=\"experience.brand.brand_name\">\n" +
    "                    <div class=\"field-select-2 field col-12\">\n" +
    "                        <label class=\"field-label\">{{\"Address\" | translate}}</label>\n" +
    "                        <div validate-rule=\"no-validation\"\n" +
    "                             validate-index=\"{{$index}}\"\n" +
    "                             validate-target=\"input[name='google_location']\">\n" +
    "                            <h-select fullwidth=\"true\"\n" +
    "                                      name=\"google_location\"\n" +
    "                                      placeholder=\"Enter address...\"\n" +
    "                                      h-model=\"experience.google_location\"\n" +
    "                                      h-options=\"address.value as address.label for address in getAddress($searchValue)\"\n" +
    "                                      minimum-input-length=\"3\"\n" +
    "                                      h-no-filteration=\"true\"\n" +
    "                                      google-autocomplete\n" +
    "                                      powered-by-google=\"true\">\n" +
    "                            </h-select>\n" +
    "                        </div>\n" +
    "\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row pb-2\">\n" +
    "                    <div class=\"field-select-2 field col-12\">\n" +
    "                        <label class=\"field-label\">{{\"Job title\" | translate}}</label>\n" +
    "                        <div ng-messages=\"form.validator.validation['position_id' + $index].errors\">\n" +
    "                            <div validate-rule=\"{{form.isCutsomPosition[$index] !== true ? 'required' : 'no-validation'}}\"\n" +
    "                                 validate-index=\"{{$index}}\"\n" +
    "                                 validate-target=\"input[name='position_id']\">\n" +
    "                                <h-select-list\n" +
    "                                    name=\"position_id\"\n" +
    "                                    placeholder=\"What position did you hold?\"\n" +
    "                                    item-key=\"id\"\n" +
    "                                    text-key=\"name\"\n" +
    "                                    ng-model=\"experience.position\"\n" +
    "                                    ng-disabled=\"form.isCutsomPosition[$index] == true\"\n" +
    "                                    items=\"form.data.positions\"\n" +
    "                                    multi=\"false\">\n" +
    "                                </h-select-list>\n" +
    "                                <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select job title\" | translate }}</div>\n" +
    "                                <div class=\"pl-1 pt-1 small col-12\">\n" +
    "                                    {{ \"Can’t find what you’re looking for\" | translate }}?\n" +
    "                                    <a ng-click=\"form.addCustomPosition($index)\" ng-href=\"{{ 'javascript:' | trusted }}\">{{ \"click here\" | translate }}</a>.\n" +
    "                                </div>\n" +
    "                                <div class=\"col-12 px-0\"\n" +
    "                                     ng-if=\"form.isCutsomPosition[$index] == true\"\n" +
    "                                     ng-messages=\"form.validator.validation['custom_position' + $index].errors\">\n" +
    "                                    <div class=\"d-flex align-items-center\">\n" +
    "                                        <div>\n" +
    "                                            <button type=\"button\"\n" +
    "                                                    ng-click=\"form.closeCustomPosition($index)\"\n" +
    "                                                    class=\"btn btn-lg p-2\">\n" +
    "                                                <i class=\"fa fa-times blue\"></i>\n" +
    "                                            </button>\n" +
    "                                        </div>\n" +
    "                                        <div class=\"field ml-2 w-100\">\n" +
    "                                            <input type=\"text\"\n" +
    "                                                   validate-index=\"{{$index}}\"\n" +
    "                                                   validate-rule=\"required\"\n" +
    "                                                   name=\"custom_position\"\n" +
    "                                                   ng-model=\"experience.position.custom_position\"/>\n" +
    "                                        </div>\n" +
    "                                    </div>\n" +
    "                                    <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select Job Title\" | translate }}</div>\n" +
    "                                </div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row align-items-end pb-2\">\n" +
    "                    <div class=\"date-row col-sm-3\" ng-messages=\"form.validator.validation['start_date' + $index].errors\">\n" +
    "                        <label tabindex=\"0\" class=\"control-label field-label\">{{'Start date' | translate}}</label>\n" +
    "                        <div validate-rule=\"required|date_range\"\n" +
    "                             validate-index=\"{{$index}}\"\n" +
    "                             validate-target=\"input[name='start_date']\">\n" +
    "                            <date-picker locale=\"en\"\n" +
    "                                         ng-model=\"experience.start_date\"\n" +
    "                                         name=\"start_date\"\n" +
    "                                         id=\"start_date\"\n" +
    "                                         date-picker-bootstrap=\"true\"\n" +
    "                                         show-icon=\"true\"\n" +
    "                                         date-format=\"DD/MM/YYYY\">\n" +
    "                            </date-picker>\n" +
    "                        </div>\n" +
    "                        <div class=\"dates-mobile-validation\">\n" +
    "                            <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select start date\" | translate }}</div>\n" +
    "                            <div role=\"alert\" ng-message=\"date_range\" class=\"error\">{{ \"Start date must be less than end date\" | translate }}</div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"date-row col-sm-3\" ng-messages=\"form.validator.validation['end_date' + $index].errors\">\n" +
    "                        <label class=\"field-label\" tabindex=\"0\">{{'End date' | translate}}</label>\n" +
    "                        <div ng-if=\"!experience.still_work_here\"\n" +
    "                             validate-rule=\"required_if_not:still_work_here\"\n" +
    "                             validate-index=\"{{$index}}\"\n" +
    "                             validate-target=\"input[name='end_date']\"\n" +
    "                             validate-trigger=\"change:.experience:input[name='start_date']\">\n" +
    "                            <date-picker locale=\"en\"\n" +
    "                                         id=\"end_date\"\n" +
    "                                         ng-model=\"experience.end_date\"\n" +
    "                                         name=\"end_date\"\n" +
    "                                         date-picker-bootstrap=\"true\"\n" +
    "                                         show-icon=\"true\"\n" +
    "                                         date-format=\"DD/MM/YYYY\"></date-picker>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"experience.still_work_here\" class=\"d-flex align-items-end currently-at-label\">\n" +
    "                            <span class=\"h-text gray italic small\">{{'I am currently in this work'|translate}}</span>\n" +
    "                        </div>\n" +
    "                        <div class=\"dates-mobile-validation\">\n" +
    "                            <div role=\"alert\" ng-message=\"required_if_not\" class=\"error\">{{ \"Please select end date\" | translate }}</div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div id=\"still_work_here{{$index}}\" class=\"date-row col-sm-6\">\n" +
    "                        <div validate-trigger=\"change:.experience:input[name='end_date']\">\n" +
    "                            <h-checkbox name=\"still_work_here\"\n" +
    "                                        ng-model=\"experience.still_work_here\"\n" +
    "                                        theme=\"active-blue\"\n" +
    "                                        on-icon=\"check-square\">\n" +
    "                                <span class=\"semi-bold\">{{'I am currently in this work' | translate}}</span>\n" +
    "                            </h-checkbox>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row m-0 dates-web-validation\">\n" +
    "                    <div class=\"col-3 p-0\" ng-messages=\"form.validator.validation['start_date' + $index].errors\">\n" +
    "                        <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select start date\" | translate }}</div>\n" +
    "                        <div role=\"alert\" ng-message=\"date_range\" class=\"error\">{{ \"Start date must be less than end date\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-3 p-0\" ng-messages=\"form.validator.validation['end_date' + $index].errors\">\n" +
    "                        <div role=\"alert\" ng-message=\"required_if_not\" class=\"error\">{{ \"Please select end date\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-line row\">\n" +
    "            <div class=\"col-12 action-group\">\n" +
    "                <div class=\"field-button field\">\n" +
    "                    <button ng-click=\"form.addNewExperience()\"\n" +
    "                            ng-disabled=\"form.data.firstJob\"\n" +
    "                            class=\"btn h-md-blue-outline-btn full-screen-btn-mobile\">\n" +
    "                        <i class=\"fa fa-plus mr-1\"></i>\n" +
    "                        {{ form.showExperience ? ('Add another employment history' | translate) : ('Add employment history' | translate) }}\n" +
    "                    </button>\n" +
    "                    &nbsp;\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
  $templateCache.put("../modules/hforms/work_eligibility/views/work_eligibility_form.html",
    "<form class=\"hform work-eligibility-form\">\n" +
    "    <div class=\"form-line row\">\n" +
    "        <div class=\"field-select field col-12\"\n" +
    "             ng-messages=\"form.validator.validation.status.errors\">\n" +
    "            <span class=\"select-wrapper\">\n" +
    "                <select name=\"status\"\n" +
    "                        validate-rule=\"required\"\n" +
    "                        class=\"select-block\"\n" +
    "                        ng-model=\"form.data.status\">\n" +
    "                    <option value=\"\" class=\"d-none\">{{ 'Select your status' | translate }}</option>\n" +
    "                    <option ng-repeat=\"status in form.status\"\n" +
    "                            value=\"{{ status.code }}\">{{ status.label }}\n" +
    "                    </option>\n" +
    "                </select>\n" +
    "                <i class=\"fa fa-chevron-down\"></i>\n" +
    "            </span>\n" +
    "            <div ng-message=\"required\" class=\"error\">{{ 'Please select your work eligibility status' | translate }}.</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>");
  $templateCache.put("../modules/hforms/education/views/education_form.html",
    "<form class=\"hform education-form\"\n" +
    "      role=\"form\" aria-label=\"{{'education' | translate}}\">\n" +
    "    <div ng-if=\"form.type !== 'job_application'\">\n" +
    "        <div class=\"form-line row\" ng-if=\"form.data.education.length == 0\">\n" +
    "            <h2 class=\"brand-settings-sub-title\">{{\"Where did you study?\" | translate}}</h2>\n" +
    "            <div class=\"field-select-2 field col-12\"\n" +
    "                 ng-messages=\"form.validator.validation['education' + $index].errors\">\n" +
    "                <div\n" +
    "                    ng-attr-validate-rule=\"no-validation\"\n" +
    "                    validate-index=\"{{$index}}\"\n" +
    "                    validate-target=\"input[name='education']\">\n" +
    "                    <h-select\n" +
    "                        fullwidth=\"true\"\n" +
    "                        h-name=\"education\"\n" +
    "                        placeholder=\"Name of your school, college, or university\"\n" +
    "                        h-model=\"form.data.education[0].Institution\"\n" +
    "                        h-options=\"institution as institution.label for institution in SearchGooglePlaceForInstitutes($searchValue)\"\n" +
    "                        minimum-input-length=\"2\"\n" +
    "                        h-no-filteration=\"true\"\n" +
    "                        powered-by-google=\"true\"\n" +
    "                        allow-new-entry=\"label\"\n" +
    "                        institution-search\n" +
    "                        on-clear-call=\"clearListItem( education.Institution, $index )\"\n" +
    "                    >\n" +
    "                        {{'Name of your school, college, or university' | translate}}\n" +
    "                    </h-select>\n" +
    "                </div>\n" +
    "\n" +
    "                <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Education is required\" | translate }}</div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div id=\"education_{{$index}}\" ng-repeat=\"education in form.data.education track by $index\">\n" +
    "            <div ng-if=\"$index >= 1\">\n" +
    "                <div class=\"sep-gray-8 float-none\"></div>\n" +
    "            </div>\n" +
    "            <div class=\"form-line row\">\n" +
    "                <div class=\"field-select-2 field col-12\" ng-messages=\"form.validator.validation['education' + $index].errors\">\n" +
    "                    <div\n" +
    "                        validate-rule=\"required\"\n" +
    "                        validate-index=\"{{$index}}\"\n" +
    "                        validate-target=\"input[name='education']\">\n" +
    "                        <h-select\n" +
    "                            fullwidth=\"true\"\n" +
    "                            h-name=\"education\"\n" +
    "                            placeholder=\"Name of your school, college, or university\"\n" +
    "                            h-model=\"education.Institution\"\n" +
    "                            h-options=\"institution as institution.label for institution in SearchGooglePlaceForInstitutes($searchValue)\"\n" +
    "                            minimum-input-length=\"3\"\n" +
    "                            h-no-filteration=\"true\"\n" +
    "                            allow-new-entry=\"label\"\n" +
    "                            powered-by-google=\"true\"\n" +
    "                            institution-search\n" +
    "                            on-clear-call=\"clearListItem( education.Institution, $index )\"\n" +
    "                        >\n" +
    "                            {{'Name of your school, college, or university' | translate}}\n" +
    "                        </h-select>\n" +
    "                    </div>\n" +
    "                    <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select education\" | translate }}</div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"education\" ng-if=\"education.Institution.name || education.Institution.label || education.has_value\">\n" +
    "                <div class=\"form-line row\" ng-show=\"!education.Institution.value && education.Institution.label\">\n" +
    "                    <div class=\"field-select-2 field col-12\">\n" +
    "                        <label>{{\"Address\" | translate}}</label>\n" +
    "                        <h-select\n" +
    "                            fullwidth=\"true\"\n" +
    "                            name=\"google_location\"\n" +
    "                            placeholder=\"Enter address...\"\n" +
    "                            h-model=\"education.google_location\"\n" +
    "                            h-options=\"address.value as address.label for address in getAddress($searchValue)\"\n" +
    "                            minimum-input-length=\"3\"\n" +
    "                            h-no-filteration=\"true\"\n" +
    "                            google-autocomplete\n" +
    "                        ></h-select>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"form-line row\">\n" +
    "                    <div class=\"field-select-2 field col-sm-6\" ng-messages=\"form.validator.validation['degree' + $index].errors\">\n" +
    "                        <div\n" +
    "                            validate-rule=\"required\"\n" +
    "                            validate-index=\"{{$index}}\"\n" +
    "                            validate-target=\"input[name='degree']\">\n" +
    "                            <label>{{'Degree' | translate}}</label>\n" +
    "                            <h-select\n" +
    "                                fullwidth=\"true\"\n" +
    "                                h-name=\"degree\"\n" +
    "                                placeholder=\"Select Qualification...\"\n" +
    "                                h-model=\"education.DegreeLookup\"\n" +
    "                                h-options=\"degree as degree.degree for degree in form.degrees\"\n" +
    "                                required=\"true\"\n" +
    "                            >\n" +
    "                                {{'Select qualification...' | translate}}\n" +
    "                            </h-select>\n" +
    "                        </div>\n" +
    "                        <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select a degree\" | translate }}</div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"field-text field col-sm-6\" ng-messages=\"form.validator.validation['discipline' + $index].errors\">\n" +
    "                        <label>{{'Area of study' | translate}}</label>\n" +
    "                        <input\n" +
    "                            validate-rule=\"required\"\n" +
    "                            validate-index=\"{{$index}}\"\n" +
    "                            name=\"discipline\"\n" +
    "                            type=\"text\"\n" +
    "                            ng-model=\"education.DisciplineLookup.name\"\n" +
    "                            placeholder=\"{{'Area of study' | translate}}\" />\n" +
    "                        <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select discipline\" | translate }}</div>\n" +
    "                    </div>\n" +
    "\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"form-line row\" ng-if=\"form.isEducationDatesMandatory\">\n" +
    "                    <div  class=\"field-month field col-6\" ng-messages=\"form.validator.validation['start_date' + $index].errors\">\n" +
    "                        <label tabindex=\"0\" class=\"control-label\">{{'Start date' | translate}}</label>\n" +
    "                        <div\n" +
    "                            validate-rule=\"{{!form.isDateOptional?'required|required_if:end_date|date_range':'required_if:end_date|date_range'}}\"\n" +
    "                            validate-index=\"{{$index}}\"\n" +
    "                            validate-target=\"input[name='start_date']\">\n" +
    "                            <month-date-picker\n" +
    "                                optional-month=\"true\"\n" +
    "                                container-prefix=\"edu-start-date\"\n" +
    "                                ng-required=\"true\"\n" +
    "                                ng-model=\"education.start_date\"\n" +
    "                                name=\"start_date\"\n" +
    "                                update-end-date=\"true\"\n" +
    "                                end-date=\"education.end_date\">\n" +
    "                            </month-date-picker>\n" +
    "                        </div>\n" +
    "                        <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select start date\" | translate }}</div>\n" +
    "                        <div role=\"alert\" ng-message=\"required_if\" class=\"error\">{{ \"Please select start date\" | translate }}</div>\n" +
    "                        <div role=\"alert\" ng-message=\"date_range\" class=\"error\">{{ \"Start date must be less than end date\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                    <div class=\"field-month field col-6\" ng-messages=\"form.validator.validation['end_date' + $index].errors\">\n" +
    "                        <label tabindex=\"0\">{{'End date' | translate}}</label>\n" +
    "                        <div\n" +
    "                            ng-if=\"!education.still_in_school\"\n" +
    "                            validate-rule=\"required_if_start:still_in_school\"\n" +
    "                            validate-index=\"{{$index}}\"\n" +
    "                            validate-target=\"input[name='end_date']\"\n" +
    "                            validate-trigger=\"change:.education:input[name='start_date']\">\n" +
    "                            <month-date-picker\n" +
    "                                container-selector=\"#edu-end-start-date\"\n" +
    "                                ng-required=\"!education.still_in_school\"\n" +
    "                                ng-model=\"education.end_date\"\n" +
    "                                name=\"end_date\"\n" +
    "                                validate-end-date=\"false\"\n" +
    "                                start-date=\"education.start_date\">\n" +
    "                            </month-date-picker>\n" +
    "                        </div>\n" +
    "                        <div ng-if=\"education.still_in_school\">\n" +
    "                            <span class=\"h-text gray italic\">{{'I am currently in school'|translate}}</span>\n" +
    "                        </div>\n" +
    "                        <div role=\"alert\" ng-message=\"required_if_start\" class=\"error\">{{ \"Please select end date\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"form-line row\" ng-if=\"form.isEducationDatesMandatory\">\n" +
    "                    <div class=\"field-checkbox field col-12 col-sm-6 offset-sm-6\"\n" +
    "                         ng-messages=\"form.validator.validation['still_in_school'].errors\">\n" +
    "                        <div validate-trigger=\"change:.education:input[name='start_date']\">\n" +
    "                            <checkbox3\n" +
    "                                name=\"still_in_school\"\n" +
    "                                value=\"true\"\n" +
    "                                label=\"{{'I am currently in school' | translate}}\"\n" +
    "                                ng-model=\"education.still_in_school\">\n" +
    "                            </checkbox3>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"form-line row\">\n" +
    "                <div class=\"col-12 action-group\">\n" +
    "                    <div class=\"field-button field\" ng-if=\"$index >= 0\">\n" +
    "                        <button type=\"button\" ng-click=\"form.deleteEducation($index)\" class=\"btn btn-outline-secondary\"><i class=\"fa fa-minus-circle\"></i> {{'Remove' | translate}}</button>\n" +
    "                    </div>\n" +
    "                    <div class=\"field-button field\" ng-if=\"$last\">\n" +
    "                        <button type=\"button\" ng-click=\"form.addNewEducation()\" class=\"btn btn-outline-secondary full-screen-btn-mobile\"><i class=\"fa fa-plus mr-1\"></i>{{'Add another education' | translate}}</button>\n" +
    "                        &nbsp;\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"form.type === 'job_application'\">\n" +
    "        <div id=\"education_{{$index}}\"\n" +
    "             ng-repeat=\"education in form.data.education track by $index\">\n" +
    "            <div class=\"p-4 mb-3 with-bg-color\">\n" +
    "                <div class=\"form-line row pb-3\">\n" +
    "                    <div class=\"col-12 d-flex justify-content-between align-items-center\">\n" +
    "                        <div class=\"section-item-label\">{{ \"Education record\" | translate }} #{{$index + 1}}</div>\n" +
    "                        <button class=\"delete-btn border-0\"\n" +
    "                                ng-if=\"form.data.education.length !== 1\"\n" +
    "                                ng-click=\"form.data.education.length > 1 && form.deleteEducation($index)\">\n" +
    "                            <i class=\"fa fa-trash delete-icon\"></i>\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row pb-2\">\n" +
    "                    <div class=\"field-select-2 field col-12\" ng-messages=\"form.validator.validation['education' + $index].errors\">\n" +
    "                        <label class=\"field-label\">{{\"Where have you studied?\" | translate}}</label>\n" +
    "                        <div\n" +
    "                            validate-rule=\"required\"\n" +
    "                            validate-index=\"{{$index}}\"\n" +
    "                            validate-target=\"input[name='education']\">\n" +
    "                            <h-select\n" +
    "                                fullwidth=\"true\"\n" +
    "                                h-name=\"education\"\n" +
    "                                placeholder=\"Name of your school, college, or university\"\n" +
    "                                h-model=\"education.Institution\"\n" +
    "                                h-options=\"institution as institution.label for institution in SearchGooglePlaceForInstitutes($searchValue)\"\n" +
    "                                minimum-input-length=\"3\"\n" +
    "                                h-no-filteration=\"true\"\n" +
    "                                allow-new-entry=\"label\"\n" +
    "                                powered-by-google=\"true\"\n" +
    "                                institution-search\n" +
    "                                on-clear-call=\"clearListItem( education.Institution, $index )\"\n" +
    "                            >\n" +
    "                                {{'Name of your school, college, or university' | translate}}\n" +
    "                            </h-select>\n" +
    "                        </div>\n" +
    "                        <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select education\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row pb-2\" ng-show=\"!education.Institution.value && education.Institution.label\">\n" +
    "                    <div class=\"field-select-2 field col-12\">\n" +
    "                        <label class=\"field-label\">{{\"Address\" | translate}}</label>\n" +
    "                        <h-select\n" +
    "                            fullwidth=\"true\"\n" +
    "                            name=\"google_location\"\n" +
    "                            placeholder=\"Enter address...\"\n" +
    "                            h-model=\"education.google_location\"\n" +
    "                            h-options=\"address.value as address.label for address in getAddress($searchValue)\"\n" +
    "                            minimum-input-length=\"3\"\n" +
    "                            h-no-filteration=\"true\"\n" +
    "                            google-autocomplete\n" +
    "                        ></h-select>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row pb-2\">\n" +
    "                    <div class=\"field-select-2 field col-sm-6\" ng-messages=\"form.validator.validation['degree' + $index].errors\">\n" +
    "                        <div\n" +
    "                            validate-rule=\"required\"\n" +
    "                            validate-index=\"{{$index}}\"\n" +
    "                            validate-target=\"input[name='degree']\">\n" +
    "                            <label class=\"field-label\">{{'Degree' | translate}}</label>\n" +
    "                            <h-select\n" +
    "                                fullwidth=\"true\"\n" +
    "                                h-name=\"degree\"\n" +
    "                                placeholder=\"Select Qualification...\"\n" +
    "                                h-model=\"education.DegreeLookup\"\n" +
    "                                h-options=\"degree as degree.degree for degree in form.degrees\"\n" +
    "                                required=\"true\"\n" +
    "                            >\n" +
    "                                {{'Select qualification...' | translate}}\n" +
    "                            </h-select>\n" +
    "                        </div>\n" +
    "                        <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select a degree\" | translate }}</div>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"field-text field col-sm-6\" ng-messages=\"form.validator.validation['discipline' + $index].errors\">\n" +
    "                        <label class=\"field-label\">{{'Area of study' | translate}}</label>\n" +
    "                        <input\n" +
    "                            validate-rule=\"required\"\n" +
    "                            validate-index=\"{{$index}}\"\n" +
    "                            name=\"discipline\"\n" +
    "                            type=\"text\"\n" +
    "                            ng-model=\"education.DisciplineLookup.name\"\n" +
    "                            placeholder=\"{{'Area of study' | translate}}\" />\n" +
    "                        <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select discipline\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row align-items-end\" ng-if=\"form.isEducationDatesMandatory\">\n" +
    "                    <div class=\"col-sm-3\">\n" +
    "                        <div class=\"form-group\" ng-messages=\"form.validator.validation['start_date' + $index].errors\">\n" +
    "                            <label tabindex=\"0\" class=\"control-label field-label\">{{'Start date' | translate}}</label>\n" +
    "                            <div\n" +
    "                                validate-rule=\"{{!form.isDateOptional?'required|required_if:end_date|date_range':'required_if:end_date|date_range'}}\"\n" +
    "                                validate-index=\"{{$index}}\"\n" +
    "                                validate-target=\"input[name='start_date']\">\n" +
    "                                <date-picker locale=\"en\"\n" +
    "                                             ng-model=\"education.start_date\"\n" +
    "                                             name=\"start_date\"\n" +
    "                                             id=\"start_date\"\n" +
    "                                             date-picker-bootstrap=\"true\"\n" +
    "                                             show-icon=\"true\"\n" +
    "                                             date-format=\"DD/MM/YYYY\">\n" +
    "                                </date-picker>\n" +
    "                            </div>\n" +
    "                            <div class=\"dates-mobile-validation\">\n" +
    "                                <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select start date\" | translate }}</div>\n" +
    "                                <div role=\"alert\" ng-message=\"required_if\" class=\"error\">{{ \"Please select start date\" | translate }}</div>\n" +
    "                                <div role=\"alert\" ng-message=\"date_range\" class=\"error\">{{ \"Start date must be less than end date\" | translate }}</div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-sm-3\">\n" +
    "                        <div class=\"form-group\" ng-messages=\"form.validator.validation['end_date' + $index].errors\">\n" +
    "                            <label tabindex=\"0\" class=\"field-label\">{{'End date' | translate}}</label>\n" +
    "                            <div\n" +
    "                                ng-if=\"!education.still_in_school\"\n" +
    "                                validate-rule=\"required_if_start:still_in_school\"\n" +
    "                                validate-index=\"{{$index}}\"\n" +
    "                                validate-target=\"input[name='end_date']\"\n" +
    "                                validate-trigger=\"change:.education:input[name='start_date']\">\n" +
    "                                <date-picker locale=\"en\"\n" +
    "                                             id=\"end_date\"\n" +
    "                                             ng-model=\"education.end_date\"\n" +
    "                                             name=\"end_date\"\n" +
    "                                             date-picker-bootstrap=\"true\"\n" +
    "                                             show-icon=\"true\"\n" +
    "                                             date-format=\"DD/MM/YYYY\"></date-picker>\n" +
    "                            </div>\n" +
    "                            <div ng-if=\"education.still_in_school\" class=\"d-flex align-items-end currently-at-label\">\n" +
    "                                <span class=\"h-text gray italic small\">{{'I am currently in school'|translate}}</span>\n" +
    "                            </div>\n" +
    "                            <div class=\"dates-mobile-validation\">\n" +
    "                                <div role=\"alert\" ng-message=\"required_if_start\" class=\"error\">{{ \"Please select end date\" | translate }}</div>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-sm-6\">\n" +
    "                        <div class=\"form-group\" ng-messages=\"form.validator.validation['still_in_school'].errors\">\n" +
    "                            <div validate-trigger=\"change:.education:input[name='start_date']\">\n" +
    "                                <h-checkbox name=\"still_in_school\"\n" +
    "                                            ng-model=\"education.still_in_school\"\n" +
    "                                            theme=\"active-blue\"\n" +
    "                                            on-icon=\"check-square\">\n" +
    "                                    <span class=\"semi-bold\">{{'I am currently in school' | translate}}</span>\n" +
    "                                </h-checkbox>\n" +
    "                            </div>\n" +
    "                        </div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "                <div class=\"form-line row m-0 dates-web-validation\">\n" +
    "                    <div class=\"col-3 p-0\" ng-messages=\"form.validator.validation['start_date' + $index].errors\">\n" +
    "                        <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select start date\" | translate }}</div>\n" +
    "                        <div role=\"alert\" ng-message=\"required_if\" class=\"error\">{{ \"Please select start date\" | translate }}</div>\n" +
    "                        <div role=\"alert\" ng-message=\"date_range\" class=\"error\">{{ \"Start date must be less than end date\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                    <div class=\"col-3 p-0\" ng-messages=\"form.validator.validation['end_date' + $index].errors\">\n" +
    "                        <div role=\"alert\" ng-message=\"required_if_start\" class=\"error\">{{ \"Please select end date\" | translate }}</div>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div class=\"form-line row\">\n" +
    "                <div class=\"col-12\">\n" +
    "                    <div ng-if=\"$last\">\n" +
    "                        <button ng-click=\"form.addNewEducation()\"\n" +
    "                                class=\"btn h-md-blue-outline-btn full-screen-btn-mobile\">\n" +
    "                            <i class=\"fa fa-plus mr-1\"></i> {{'Add another education' | translate}}\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
  $templateCache.put("../modules/hforms/skills/views/skills_form.html",
    "<form class=\"hform skills-form\">\n" +
    "    <div class=\"form-line row\">\n" +
    "        <div class=\"field-select-2 field col-12\" ng-messages=\"form.validator.validation.skills.errors\">\n" +
    "            <div\n" +
    "                ng-attr-validate-rule=\"{{ form.isOptional() ? 'no-validation' : 'multi-selection:3'}}\"\n" +
    "                validate-target=\"input[name='skills']\"\n" +
    "            >\n" +
    "                <h-select\n" +
    "                    fullwidth=\"true\"\n" +
    "                    h-options=\"item as item.name for item in form.skillsList\"\n" +
    "                    required=\"!data.skills.optional\"\n" +
    "                    multiple=\"true\"\n" +
    "                    h-name=\"skills\"\n" +
    "                    h-model=\"form.data.skills\"\n" +
    "                    placeholder=\"{{ 'Search for skills you have or type to add' | translate }}\"\n" +
    "                ></h-select>\n" +
    "            </div>\n" +
    "            <div role=\"alert\" ng-message=\"multi-selection\" class=\"error\">\n" +
    "                {{ \"Please select at least three skills\" | translate }}\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
  $templateCache.put("../modules/hforms/availability/views/availability_form.html",
    "<form class=\"hform availability-form\">\n" +
    "    <div class=\"form-line\">\n" +
    "        <div class=\"field-radio field\"\n" +
    "             validate-rule=\"required\"\n" +
    "             validate-target=\"[name='availability']\"\n" +
    "             ng-messages=\"form.validator.validation.availability.errors\">\n" +
    "            <div class=\"row\">\n" +
    "                <div class=\"col-12 col-sm-4\">\n" +
    "                    <label class=\"d-flex\">\n" +
    "                        <input\n" +
    "                            type=\"radio\"\n" +
    "                            ng-model=\"form.data.availability\"\n" +
    "                            name=\"availability\"\n" +
    "                            value=\"anytime\"\n" +
    "                        />\n" +
    "                        <span class=\"section-text ml-2\">{{ 'Any time' | translate }}</span>\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "                <div class=\"col-12 col-sm-4\">\n" +
    "                    <label class=\"d-flex\">\n" +
    "                        <input\n" +
    "                            type=\"radio\"\n" +
    "                            ng-model=\"form.data.availability\"\n" +
    "                            name=\"availability\"\n" +
    "                            value=\"full_time\"\n" +
    "                        />\n" +
    "                        <span class=\"section-text ml-2\">{{ 'Full time' | translate }}</span>\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "                <div class=\"col-12 col-sm-4\">\n" +
    "                    <label class=\"d-flex\">\n" +
    "                        <input\n" +
    "                            type=\"radio\"\n" +
    "                            ng-model=\"form.data.availability\"\n" +
    "                            name=\"availability\"\n" +
    "                            value=\"part_time\"\n" +
    "                        />\n" +
    "                        <span class=\"section-text ml-2\">{{ 'Part time' | translate }}</span>\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-message=\"required\" class=\"error\">{{\"Please select one of the options above\"|translate}}</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>");
  $templateCache.put("../modules/hforms/references/views/application_references_form.html",
    "<form class=\"hform references-form\">\n" +
    "    <div id=\"reference-{{$index}}\" ng-class=\"{ 'p-4 mb-3 with-bg-color': form.source === 'JOB_APPLY' }\" ng-repeat=\"reference in form.data.references track by $index\">\n" +
    "        <div ng-if=\"$index >= 1 && form.source !== 'JOB_APPLY'\" class=\"row\">\n" +
    "            <div class=\"space-xs\"></div>\n" +
    "            <div class=\"sep-gray-8 float-none\"></div>\n" +
    "        </div>\n" +
    "        <div ng-if=\"form.source === 'JOB_APPLY'\" class=\"form-line row pb-3\">\n" +
    "            <div class=\"col-12 d-flex justify-content-between align-items-center\">\n" +
    "                <div class=\"section-item-label\">{{ \"Reference\" | translate }} #{{$index + 1}}</div>\n" +
    "                <button class=\"delete-btn border-0\" ng-if=\"form.data.references.length > 1\"\n" +
    "                     ng-click=\"form.data.references.length > 1 && form.removeReference($index)\">\n" +
    "                    <i class=\"fa fa-trash delete-icon\"></i>\n" +
    "                </button>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-line row\" ng-class=\"{ 'pb-2': form.source === 'JOB_APPLY' }\">\n" +
    "            <div class=\"field-text field col-12 col-sm-6\" ng-messages=\"form.validator.validation['name' + $index].errors\">\n" +
    "                <label for=\"name_references_form{{$index}}\" class=\"field-label\">{{\"Name\" | translate}}</label>\n" +
    "                <input\n" +
    "                        validate-rule=\"required\"\n" +
    "                        validate-index=\"{{$index}}\"\n" +
    "                        id=\"name_references_form{{$index}}\"\n" +
    "                        type=\"text\"\n" +
    "                        name=\"name\"\n" +
    "                        ng-model=\"reference.name\" />\n" +
    "                <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Reference name is required\" | translate }}</div>\n" +
    "            </div>\n" +
    "            <div class=\"field-text field col-12 col-sm-6\" ng-messages=\"form.validator.validation['email' + $index].errors\">\n" +
    "                <label for=\"email_references_form{{$index}}\" class=\"field-label\">{{\"Email\" | translate}}</label>\n" +
    "                <input\n" +
    "                        validate-rule=\"required|email\"\n" +
    "                        validate-index=\"{{$index}}\"\n" +
    "                        id=\"email_references_form{{$index}}\"\n" +
    "                        name=\"email\"\n" +
    "                        type=\"email\"\n" +
    "                        ng-model=\"reference.email\" />\n" +
    "                <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Reference email is required\" | translate }}</div>\n" +
    "                <div role=\"alert\" ng-message=\"email\" class=\"error\">{{ \"Invalid email\" | translate }}</div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"form-line row\">\n" +
    "            <div class=\"field-text field col-12 col-sm-6\">\n" +
    "                <label for=\"company_references_form{{$index}}\" class=\"field-label\">{{\"Company\" | translate}}</label>\n" +
    "                <input  type=\"text\"\n" +
    "                        id=\"company_references_form{{$index}}\"\n" +
    "                        name=\"company\"\n" +
    "                        ng-model=\"reference.brand_name\" />\n" +
    "            </div>\n" +
    "            <div class=\"field-text field col-12 col-sm-6\" ng-messages=\"form.validator.validation['phone' + $index].errors\">\n" +
    "                <label for=\"phone_references_form{{$index}}\" class=\"field-label\">{{\"Phone\" | translate}}<span ng-if=\"form.source === 'JOB_APPLY'\" class=\"field-label\"> {{\"number\" | translate}}</span></label>\n" +
    "                <input\n" +
    "                    ng-model=\"reference.phone\"\n" +
    "                    type=\"tel\"\n" +
    "                    id=\"phone_references_form{{$index}}\"\n" +
    "                    name=\"phone\"\n" +
    "                    validate-index=\"{{$index}}\"\n" +
    "                    validate-rule=\"phoneNumber\"\n" +
    "                    h-intl-tel-input />\n" +
    "                <div role=\"alert\" ng-message=\"phoneNumber\" class=\"error\">{{ \"Invalid phone\" | translate }}</div>\n" +
    "            </div>\n" +
    "        </div>\n" +
    "        <div class=\"text-right\" ng-if=\"form.source !== 'JOB_APPLY' && form.data.references.length > 1\">\n" +
    "            <button type=\"button\" ng-click=\"form.removeReference($index)\" class=\"btn btn-default\"><i class=\"fa fa-minus-circle\"></i> {{'Remove' | translate}}</button>\n" +
    "            <div class=\"space-xs\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-class=\"{ 'text-right': form.source !== 'JOB_APPLY' }\">\n" +
    "        <button ng-click=\"form.addReference()\"\n" +
    "                class=\"btn\"\n" +
    "                ng-class=\"{'h-md-blue-outline-btn full-screen-btn-mobile': form.source === 'JOB_APPLY', 'btn-default': form.source !== 'JOB_APPLY'}\">\n" +
    "            <i class=\"fa\" ng-class=\"{'fa-plus mr-1': form.source === 'JOB_APPLY', 'fa-plus-circle': form.source !== 'JOB_APPLY'}\"></i>\n" +
    "            {{'Add another reference' | translate}}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
  $templateCache.put("../modules/hforms/verified_location/views/verified_location_form.html",
    "<form class=\"hform verified-location-form\">\n" +
    "    <div class=\"section-title\">\n" +
    "        {{\"Your primary residence\" | translate}}\n" +
    "    </div>\n" +
    "    <div class=\"d-flex mb-2\">\n" +
    "        <hui-input-checkbox ng-model=\"form.data.useCurrentLocation\"\n" +
    "                            on-change=\"form.onUseCurrentLocationChanged()\"\n" +
    "                            disabled=\"form.isLoadingPrimaryResidence\"\n" +
    "                            h-name=\"useCurrentLocation\">\n" +
    "            {{ 'Use my current location as my primary residence.' | translate }}\n" +
    "        </hui-input-checkbox>\n" +
    "    </div>\n" +
    "    <div ng-if=\"form.data.useCurrentLocation\">\n" +
    "        <hui-input-text ng-model=\"form.data.primaryResidence.label\"\n" +
    "                        placeholder=\"{{ 'Loading...' | translate }}\"\n" +
    "                        type=\"text\"\n" +
    "                        full-width=\"true\"\n" +
    "                        disabled=\"true\"\n" +
    "                        h-name=\"location\">\n" +
    "        </hui-input-text>\n" +
    "    </div>\n" +
    "    <div ng-if=\"!form.data.useCurrentLocation\"\n" +
    "         class=\"form-line row\"\n" +
    "         ng-messages=\"form.validator.validation.primaryLocation.errors\">\n" +
    "        <div class=\"field-select field col-12\"\n" +
    "             validate-rule=\"required\"\n" +
    "             validate-target=\"input[name='primaryLocation']\">\n" +
    "            <div class=\"harri-select2\">\n" +
    "                <h-select-list-async\n" +
    "                    name=\"primaryLocation\"\n" +
    "                    placeholder=\"{{ 'Search for your primary location' | translate }}\"\n" +
    "                    item-key=\"id\"\n" +
    "                    text-key=\"label\"\n" +
    "                    ng-model=\"form.data.primaryLocation\"\n" +
    "                    multi=\"false\"\n" +
    "                    allow-init-items=\"true\"\n" +
    "                    search-initially-visible=\"true\"\n" +
    "                    filter-debounce=\"500\"\n" +
    "                    ng-change=\"form.onLocationChanged(items)\"\n" +
    "                    result-callback=\"form.getLocationsBySearchQuery($event)\"\n" +
    "                ></h-select-list-async>\n" +
    "            </div>\n" +
    "            <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ 'Please select your primary location' | translate }}</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>");
  $templateCache.put("../modules/hforms/job_preferred_location/views/job_preferred_location_form.html",
    "<form class=\"hform job-preferred-location-form\">\n" +
    "    <div class=\"form-line row\"\n" +
    "         ng-messages=\"form.validator.validation.location.errors\">\n" +
    "        <div class=\"field-select field col-12\"\n" +
    "             validate-rule=\"at_least_one\"\n" +
    "             validate-target=\"input[type='checkbox']\">\n" +
    "            <div ng-repeat=\"location in form.locations\">\n" +
    "                <h-checkbox name=\"location\"\n" +
    "                            theme=\"active-blue\"\n" +
    "                            on-icon=\"check-square\"\n" +
    "                            h-aria-label=\"{{ location.formatted_address }}\"\n" +
    "                            ng-model=\"location.selected\">\n" +
    "                    {{ location.formatted_address }}\n" +
    "                </h-checkbox>\n" +
    "            </div>\n" +
    "            <div role=\"alert\" ng-message=\"at_least_one\" class=\"error\">{{ 'Please select one location at least' | translate }}</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>");
  $templateCache.put("../modules/hforms/screening_answer/views/screening_answer_form.html",
    "<form class=\"hform screening-form\">\n" +
    "    <div ng-if=\"form.bulk\" class=\"form-line d-flex justify-content-between px-3 py-2 my-3 job-container\">\n" +
    "        <div class=\"job-title\">{{form.applied_job_names}}</div>\n" +
    "        <button ng-if=\"form.formCode === 'screening_forms'\" class=\"btn remove-btn p-0\" ng-click=\"form.onRemoveJob(form.questionsFormId, form.appliedJobIds)\">\n" +
    "            <i class=\"fa fa-times\"></i> {{ 'Remove job' | translate }}\n" +
    "        </button>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-if=\"form.hasVideo\" class=\"row mb-1\">\n" +
    "        <div class=\"col-12\">\n" +
    "            <hui-input-checkbox h-name=\"text_for_all\" ng-model=\"form.textForAll\" on-change=\"form.onTextToggle()\">\n" +
    "                <span>{{ 'I require an alternative to video responses due to a disability' | translate }}</span>\n" +
    "            </hui-input-checkbox>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div class=\"question form-line row\" ng-repeat=\"question in form.questions track by question.id\">\n" +
    "        <div class=\"field field-text col-12 text-only\"\n" +
    "             ng-messages=\"form.validator.validation['text_answer' + $index].errors\"\n" +
    "             ng-if=\"question.type === 'TEXT' || !question.type\">\n" +
    "            <hr class=\"my-3\" ng-if=\"$index !== 0\"/>\n" +
    "            <div for=\"text_answer{{$index}}\" class=\"mb-3\">\n" +
    "                <span class=\"question-title\">{{ question.question }}</span><sup ng-if=\"question.is_mandatory\" class=\"star\">*</sup>\n" +
    "                <span class=\"is-optional-text\" ng-if=\"!question.is_mandatory\">({{ 'optional' | translate }})</span>\n" +
    "            </div>\n" +
    "            <textarea name=\"text_answer\"\n" +
    "                      id=\"text_answer{{$index}}\"\n" +
    "                      maxlength=\"3000\"\n" +
    "                      ng-model=\"question.answers[0].answer\"\n" +
    "                      placeholder=\"{{ 'Enter your answer here' | translate }}...\"\n" +
    "                      ng-attr-validate-rule=\"{{ question.is_mandatory? 'required': 'no-validation' }}\"\n" +
    "                      validate-index=\"{{$index}}\"\n" +
    "                    ></textarea>\n" +
    "            <div class=\"word-count pr-1\"\n" +
    "                 ng-class=\"{\n" +
    "                        'error': (3000 - (question.answers[0].answer.length || 0)) === 0\n" +
    "                    }\">\n" +
    "                <span>\n" +
    "                  {{3000 - (question.answers[0].answer.length || 0)}}\n" +
    "                </span>\n" +
    "                {{'characters remaining'|translate}}\n" +
    "            </div>\n" +
    "            <div role=\"alert\" ng-if=\"question.is_mandatory\" ng-message=\"required\" class=\"error\">{{ \"Please add an answer\" | translate }}</div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"field field-text col-12 text-video\"\n" +
    "             ng-messages=\"form.validator.validation['text_answer' + $index].errors\"\n" +
    "             ng-if=\"question.type === 'TEXT_VIDEO' || !question.type\">\n" +
    "            <hr class=\"my-3\" ng-if=\"$index !== 0\"/>\n" +
    "            <div tabindex=\"0\" class=\"mb-3\">\n" +
    "                <span class=\"question-title\">{{ question.question }}</span><sup ng-if=\"question.is_mandatory\" class=\"star\">*</sup>\n" +
    "                <span class=\"is-optional-text\" ng-if=\"!question.is_mandatory\">({{ 'optional' | translate }})</span>\n" +
    "            </div>\n" +
    "            <div class=\"row actions\">\n" +
    "                <div class=\"col-12 col-sm-6 answer-btn video-btn\">\n" +
    "                    <video-answer question=\"question\"\n" +
    "                                  form_id=\"{{form.questionsFormId}}\"\n" +
    "                                  application_id=\"{{form.applicationId}}\"\n" +
    "                                  bulk=\"form.bulk\"\n" +
    "                                  user_id=\"form.userId\"\n" +
    "                                  job_ids=\"form.appliedJobIds\"\n" +
    "                                  ng-model=\"question.answers[0]\"\n" +
    "                                  on-video-published=\"form.onVideoPublished(video, $index)\"\n" +
    "                                  id=\"{{ 'video-' + question.id }}\">\n" +
    "                        <button role=\"button\" aria-label=\"{{'Answer with video'|translate}}\" class=\"btn h-md-blue-outline-btn text-left\">\n" +
    "                            <i class=\"fa fa-video-camera mr-2\"></i> {{'Answer with video'|translate}}\n" +
    "                        </button>\n" +
    "                    </video-answer>\n" +
    "                </div>\n" +
    "                <div ng-if=\"form.textForAll && (!question.answers[0].external_video && !(question.answers[0].media_uuid || question.answers[0].thumbnail_href))\"\n" +
    "                    class=\"col-12 col-sm-6 answer-btn text-btn\">\n" +
    "                    <span>\n" +
    "                        <checkbox6 name=\"answer_text\" value=\"2\"\n" +
    "                                   label=\"'Answer with text'|translate\"\n" +
    "                                   ng-change=\"form.onAnswerWithTextCheck(value, $index)\"\n" +
    "                                   ng-model=\"question.answer_with_text\">\n" +
    "                        </checkbox6>\n" +
    "                    </span>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div ng-show=\"form.textForAll && (!question.answers[0].external_video && !(question.answers[0].media_uuid || question.answers[0].thumbnail_href) && question.answer_with_text)\">\n" +
    "                <textarea name=\"text_answer\"\n" +
    "                          ng-model=\"question.answers[0].answer\"\n" +
    "                          maxlength=\"3000\"\n" +
    "                          placeholder=\"{{ 'Enter your answer here' | translate }}...\"\n" +
    "                          ng-attr-validate-rule=\"{{ (\n" +
    "                                question.is_mandatory &&\n" +
    "                                !question.question.answers[0].answer &&\n" +
    "                                !question.answers[0].external_video &&\n" +
    "                                !question.answers[0].media_uuid &&\n" +
    "                                !question.answers[0].original_file\n" +
    "                            ) ? 'required': 'no-validation' }}\"\n" +
    "                          validate-index=\"{{$index}}\"\n" +
    "                        ></textarea>\n" +
    "                <div class=\"word-count\"\n" +
    "                     ng-class=\"{\n" +
    "                        'error': (3000 - (question.answers[0].answer.length || 0)) == 0\n" +
    "                    }\">\n" +
    "                    <span>\n" +
    "                      {{3000 - (question.answers[0].answer.length || 0)}}\n" +
    "                    </span>\n" +
    "                    {{'characters remaining'|translate}}\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please add an answer\" | translate }}</div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"field field-radio col-12\"\n" +
    "             ng-messages=\"form.validator.validation['yes_no_answer' + question.id + '_' + $index].errors\"\n" +
    "             ng-if=\"question.type === 'YES_NO' || !question.type\">\n" +
    "            <hr class=\"my-3\" ng-if=\"$index !== 0\"/>\n" +
    "            <div tabindex=\"0\" class=\"mb-3\">\n" +
    "                <span class=\"question-title\">{{ question.question }}</span><sup ng-if=\"question.is_mandatory\" class=\"star\">*</sup>\n" +
    "                <span class=\"is-optional-text\" ng-if=\"!question.is_mandatory\">({{ 'optional' | translate }})</span>\n" +
    "            </div>\n" +
    "            <div class=\"row\"\n" +
    "                 role=\"radiogroup\"\n" +
    "                 validate-rule=\"{{ question.is_mandatory? 'required': 'no-validation' }}\"\n" +
    "                 validate-index=\"{{$index}}\"\n" +
    "                 validate-target=\"[name='yes_no_answer{{question.id}}_']\"\n" +
    "                 >\n" +
    "                <div class=\"col-sm-2\">\n" +
    "                    <label class=\"d-flex\">\n" +
    "                        <input type=\"radio\"\n" +
    "                               ng-value=\"{{question.options[0].id}}\"\n" +
    "                               name=\"yes_no_answer{{question.id}}_\"\n" +
    "                               ng-model=\"question.temp_answers[0]\"/>\n" +
    "                        <span class=\"option-label ml-2\">{{question.options[0].content | translate}}</span>\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "                <div class=\"col-sm-2\">\n" +
    "                    <label class=\"d-flex\">\n" +
    "                        <input type=\"radio\"\n" +
    "                               ng-value=\"{{question.options[1].id}}\"\n" +
    "                               name=\"yes_no_answer{{question.id}}_\"\n" +
    "                               ng-model=\"question.temp_answers[0]\"/>\n" +
    "                        <span class=\"option-label ml-2\">{{question.options[1].content | translate}}</span>\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select an answer\" | translate }}</div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-12 field field-radio\"\n" +
    "             ng-messages=\"form.validator.validation['single_answer' + question.id + '_' + $index].errors\"\n" +
    "             ng-if=\"question.type === 'SINGLE_CHOICE' || !question.type\">\n" +
    "            <hr class=\"my-3\" ng-if=\"$index !== 0\"/>\n" +
    "            <div tabindex=\"0\" class=\"mb-3\">\n" +
    "                <span class=\"question-title\">{{ question.question }}</span><sup ng-if=\"question.is_mandatory\" class=\"star\">*</sup>\n" +
    "                <span class=\"is-optional-text\" ng-if=\"!question.is_mandatory\">({{ 'optional' | translate }})</span>\n" +
    "            </div>\n" +
    "            <div class=\"row\"\n" +
    "                 role=\"radiogroup\"\n" +
    "                 validate-rule=\"{{ question.is_mandatory? 'required': 'no-validation' }}\"\n" +
    "                 validate-index=\"{{$index}}\"\n" +
    "                 validate-target=\"[type='radio']\">\n" +
    "                <div class=\"col-12\"\n" +
    "                     ng-class=\"{ 'col-md-6': !question.long_options }\"\n" +
    "                     ng-repeat=\"option in question.options\">\n" +
    "                    <label class=\"d-flex\">\n" +
    "                        <input type=\"radio\"\n" +
    "                               ng-value=\"{{option.id}}\"\n" +
    "                               name=\"single_answer{{question.id}}_\"\n" +
    "                               ng-model=\"question.temp_answers[0]\"/>\n" +
    "                        <span class=\"option-label ml-2\">{{option.content}}</span>\n" +
    "                    </label>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select an answer\" | translate }}</div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-12 field field-radio\"\n" +
    "             ng-messages=\"form.validator.validation['multi_answer' + question.id + '_' + $index].errors\"\n" +
    "             ng-if=\"question.type === 'MULTIPLE_CHOICE' || !question.type\">\n" +
    "            <hr class=\"my-3\" ng-if=\"$index !== 0\"/>\n" +
    "            <div tabindex=\"0\" class=\"mb-3\">\n" +
    "                <span class=\"question-title\">{{ question.question }}</span> <sup ng-if=\"question.is_mandatory\" class=\"star\">*</sup>\n" +
    "                <span class=\"is-optional-text\" ng-if=\"!question.is_mandatory\">({{ 'optional' | translate }})</span>\n" +
    "            </div>\n" +
    "            <div class=\"row\"\n" +
    "                 validate-rule=\"{{ question.is_mandatory? 'required': 'no-validation' }}\"\n" +
    "                 validate-target=\"[type='checkbox']\"\n" +
    "                 validate-trigger-target=\"true\"\n" +
    "                 validate-index=\"{{$index}}\">\n" +
    "                <div class=\"col-12\"\n" +
    "                     ng-class=\"{ 'col-md-6': !question.long_options }\"\n" +
    "                     ng-repeat=\"option in question.options\">\n" +
    "                    <h-checkbox\n" +
    "                        value=\"{{option.id}}\"\n" +
    "                        name=\"multi_answer{{question.id}}_\"\n" +
    "                        h-aria-label=\"{{option.content}}\"\n" +
    "                        theme=\"active-blue\"\n" +
    "                        on-icon=\"check-square\"\n" +
    "                        ng-model=\"question.temp_answers[option.id]\">\n" +
    "                        <span class=\"option-label\">{{option.content}}</span>\n" +
    "                    </h-checkbox>\n" +
    "                </div>\n" +
    "            </div>\n" +
    "            <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select an answer\" | translate }}</div>\n" +
    "        </div>\n" +
    "\n" +
    "        <div class=\"col-12 field\"\n" +
    "             ng-messages=\"form.validator.validation['country_' + question.id + '_' + $index].errors\"\n" +
    "             ng-if=\"question.type == 'COUNTRIES' || !question.type\">\n" +
    "            <hr class=\"my-3\" ng-if=\"$index !== 0\"/>\n" +
    "            <div class=\"mb-3\">\n" +
    "                <span class=\"question-title\">{{ question.question }}</span> <sup ng-if=\"question.is_mandatory\" class=\"star\">*</sup>\n" +
    "                <span class=\"is-optional-text\" ng-if=\"!question.is_mandatory\">({{ 'optional' | translate }})</span>\n" +
    "            </div>\n" +
    "            <span class=\"select-wrapper\">\n" +
    "                <select validate-rule=\"{{ question.is_mandatory? 'required': 'no-validation' }}\"\n" +
    "                        validate-index=\"{{ $index }}\"\n" +
    "                        ng-model=\"question.answer_text\"\n" +
    "                        name=\"type\"\n" +
    "                        class=\"select-block\">\n" +
    "                    <option value=\"\" class=\"hidden d-none\">{{ 'Select country' | translate }}</option>\n" +
    "                    <option ng-repeat=\"option in form.countries\" value=\"{{ option.Description }}\">{{ option.Description }}</option>\n" +
    "                </select>\n" +
    "                <i class=\"fa fa-chevron-down\"></i>\n" +
    "            </span>\n" +
    "            <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Please select an answer\" | translate }}</div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "</form>");
  $templateCache.put("../modules/hforms/profile_photo/views/profile_photo_form.html",
    "<form class=\"hform profile-photo-form\"\n" +
    "      role=\"form\"\n" +
    "      aria-label=\"{{'upload profile photo'| translate}}\">\n" +
    "    <div class=\"section-description mb-3 add-photo-label-mobile\">{{ \"Add a photo to create a media-rich profile\" | translate }}.</div>\n" +
    "    <div class=\"row\">\n" +
    "        <div class=\"col-md-12 d-flex upload-profile-photo-wrapper\">\n" +
    "            <div class=\"user-upload-icon mr-3\" id=\"photo-preview\"\n" +
    "                 ngf-drop=\"onProfilePicSelect($files)\"\n" +
    "                 ngf-drop-available=\"dropSupported=true\"\n" +
    "                 ngf-drag-over-class=\"dragOverClass($event)\">\n" +
    "                <img ng-if=\"profile_pic_url\" ng-src=\"{{profile_pic_url}}\"/>\n" +
    "            </div>\n" +
    "            <div>\n" +
    "                <div class=\"section-description mb-3 add-photo-label-web\">{{ \"Add a photo to create a media-rich profile\" | translate }}.</div>\n" +
    "                <div>\n" +
    "                    <div\n" +
    "                        profile-pic-upload\n" +
    "                        user-id=\"{{form.userId}}\"\n" +
    "                        profile-pic-action=\"profile_photo\"\n" +
    "                        profile-pic-tracking=\"true\"\n" +
    "                        profile-pic-tracking-category=\"{{ form.source === 'SINGLE_APPLY' ? 'job_apply' : 'multiple_apply' }}\"\n" +
    "                        ng-upload-method=\"PUT\"\n" +
    "                        ng-hide=\"profile_pic_progress_status == 'IN_PROGRESS'\"\n" +
    "                        class=\"drop-upload\">\n" +
    "                        <button accept=\"image/*\"\n" +
    "                                ngf-select=\"onProfilePicSelect($files)\"\n" +
    "                                onclick=\"this.value = null\"\n" +
    "                                title=\"{{'choose photo'|translate}}\" class=\"btn h-md-blue-outline-btn full-screen-btn-mobile choose-photo-btn\">\n" +
    "                        <span ng-switch=\"profile_pic_progress_status\">\n" +
    "                            <span ng-switch-when=\"NTHN\">\n" +
    "                               <i class=\"fa fa-cloud-upload d-none d-sm-inline\"></i>\n" +
    "                                {{'Choose photo'|translate}} ({{'optional'|translate}})\n" +
    "                            </span>\n" +
    "                            <span ng-switch-when=\"DONE\"\n" +
    "                                  ng-click=\"apply_reset_upload()\"><i class=\"fa fa-pencil\"></i>{{'change'|translate}}\n" +
    "                            </span>\n" +
    "                            <span ng-switch-when=\"ERROR\"\n" +
    "                                  ng-click=\"apply_reset_upload()\"><i class=\"fa fa-times\"></i> {{'Try Again'|translate}}\n" +
    "                            </span>\n" +
    "                        </span>\n" +
    "                        </button>\n" +
    "                    </div>\n" +
    "                    <div class=\"m-1\" ng-show=\"profile_pic_progress_status == 'IN_PROGRESS' && !isIE\">\n" +
    "                        <upload-progress title=\"profile pic\"\n" +
    "                                         status=\"profile_pic_progress_status\"\n" +
    "                                         progress=\"profile_pic_progress\"></upload-progress>\n" +
    "                    </div>\n" +
    "\n" +
    "                    <div class=\"m-1\" ng-show=\"profile_pic_progress_status == 'IN_PROGRESS' && isIE\">\n" +
    "                        <i class=\"fa fa-circle-o-notch fa-spin\"></i> {{'Uploading'|translate}}...\n" +
    "                    </div>\n" +
    "                </div>\n" +
    "\n" +
    "                <div class=\"hint-text mt-3\">{{ \"Hint: you can add many more images later on\" | translate }}!</div>\n" +
    "            </div>\n" +
    "\n" +
    "        </div>\n" +
    "\n" +
    "    </div>\n" +
    "</form>");
  $templateCache.put("../modules/hforms/job_apply_disclaimer/views/job_apply_disclaimer_form.html",
    "<form class=\"hform job-apply-disclaimer-form\" novalidate\n" +
    "      role=\"form\"\n" +
    "      aria-label=\"{{'job apply disclaimer' | translate}}\">\n" +
    "    <div class=\"form-line row mb-2\" ng-if=\"form.disclaimers['JOB_APPLY']\">\n" +
    "        <div class=\"col-12\">\n" +
    "            <div ng-bind-html=\"form.disclaimers['JOB_APPLY'] | trusted\"></div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "    <div ng-if=\"form.disclaimers['JOB_APPLY_CONSENT']\"\n" +
    "         ng-messages=\"form.validator.validation['disclaimer_consent'].errors\">\n" +
    "        <div class=\"form-line d-flex\">\n" +
    "            <div class=\"job-apply-consent text-center mr-2\" validate-rule=\"required\"\n" +
    "                 validate-target=\"input[type='checkbox']\">\n" +
    "                <h-checkbox ng-model=\"form.data.disclaimer_consent\"\n" +
    "                            name=\"disclaimer_consent\"\n" +
    "                            theme=\"active-blue\"\n" +
    "                            on-icon=\"check-square\"\n" +
    "                            h-label-id=\"JOB_APPLY_CONSENT\"\n" +
    "                            class=\"active-blue\">\n" +
    "                </h-checkbox>\n" +
    "            </div>\n" +
    "            <div id=\"JOB_APPLY_CONSENT\" class=\"small\"\n" +
    "                 ng-bind-html=\"form.disclaimers['JOB_APPLY_CONSENT'] | trusted\"></div>\n" +
    "        </div>\n" +
    "        <div role=\"alert\" ng-message=\"required\" class=\"error\">{{ \"Required\" | translate }}</div>\n" +
    "    </div>\n" +
    "</form>\n" +
    "");
  $templateCache.put("../scripts/global-directives/html/language-selector.html",
    "<div class=\"language-selector\">\n" +
    "    <div ng-show=\"location === 'header'\">\n" +
    "        <a ng-href=\"{{ 'javascript:' | trusted }}\"\n" +
    "           data-toggle=\"dropdown\"\n" +
    "           aria-expanded=\"false\"\n" +
    "           ng-show=\"source !== 'source_hire_header'\"\n" +
    "           class=\"item language-button\">\n" +
    "            {{'Language' | translate}}\n" +
    "            <i class=\"fa fa-caret-down\"></i>\n" +
    "        </a>\n" +
    "        <ul class=\"lang-dropdown\"\n" +
    "            ng-if=\"source !== 'source_hire_header' || !loading\"\n" +
    "            ng-class=\"{'hidden d-none': source !== 'source_hire_header'}\"\n" +
    "            role=\"menu\">\n" +
    "            <li ng-repeat=\"language in languages\"\n" +
    "                ng-class=\"{'active': currentLang === language.code && source === 'source_hire_header'}\">\n" +
    "                <a ng-click=\"changeLang(language.code)\"\n" +
    "                   ng-class=\"{'active': currentLang === language.code && source !== 'source_hire_header'}\"\n" +
    "                   class=\"uppercase\"\n" +
    "                   data-lang=\"{{language.code}}\"\n" +
    "                   ng-href=\"{{ 'javascript:' | trusted }}\">\n" +
    "                    <span class=\"language-name\">{{language.name}}</span>\n" +
    "                    <i class=\"fa fa-check check-icon\"\n" +
    "                       ng-if=\"currentLang === language.code && source === 'source_hire_header'\">\n" +
    "                    </i>\n" +
    "                </a>\n" +
    "            </li>\n" +
    "        </ul>\n" +
    "        <div class=\"loader\"\n" +
    "             ng-if=\"source === 'source_hire_header' && loading\">\n" +
    "            <i class=\"fa fa-spinner fa-spin\"></i>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "    <div ng-show=\"location === 'footer'\">\n" +
    "        <span class=\"select-wrapper\">\n" +
    "            <select name=\"language_change\"\n" +
    "                    ng-change=\"changeLang()\"\n" +
    "                    ng-model=\"defaultLang\"\n" +
    "                    ng-options=\"language.code as language.name for language in languages\"\n" +
    "                    class=\"select-block\">\n" +
    "            </select>\n" +
    "        </span>\n" +
    "    </div>\n" +
    "</div>\n" +
    "");
  $templateCache.put("../hmodules/components/h-nunjucks/h-nunjucks.component.html",
    "<div class=\"h-nunjucks\"></div>");
  $templateCache.put("../modules/forms/layouts/login_modal_layout.html",
    "<div h-login-layout>\n" +
    "\n" +
    "    <!-- Modal -->\n" +
    "    <div class=\"modal fade modal-xs-fullscreen\" id=\"login-dialog\" tabindex=\"-1\" role=\"dialog\" >\n" +
    "        <div class=\"modal-dialog\">\n" +
    "            <div class=\"modal-content h-modal-content w450\">\n" +
    "\n" +
    "                <button type=\"button\" class=\"close h-modal-close black bold position-absolute\" automation=\"closeModal\" data-dismiss=\"modal\"><span aria-hidden=\"true\">&times;</span><span class=\"sr-only\">Close</span></button>\n" +
    "\n" +
    "                <h-form-layout view=\"login_layout\" ng-if=\"loginOpened\">\n" +
    "                    <div ng-transclude></div>\n" +
    "                </h-form-layout>\n" +
    "\n" +
    "            </div>\n" +
    "        </div>\n" +
    "    </div>\n" +
    "\n" +
    "</div>");
  $templateCache.put("../modules/forms/views/login_flow.html",
    "<div class=\"login-modal-wrap\">\n" +
    "    <h-form-layout view=\"login_modal_layout\" id=\"login-modal\">\n" +
    "        <h-form-flow name=\"login-modal\">\n" +
    "            <h-form view=\"login\"></h-form>\n" +
    "            <h-form view=\"reset_password/enter_email\"></h-form>\n" +
    "            <h-form view=\"reset_password/reset_email_sent\"></h-form>\n" +
    "            <h-form view=\"reset_password/new_password\"></h-form>\n" +
    "            <h-form view=\"reset_password/updated_successfully\"></h-form>\n" +
    "            <h-form view=\"reset_password/invalid_token\"></h-form>\n" +
    "            <h-form view=\"activated_successfully\"></h-form>\n" +
    "        </h-form-flow>\n" +
    "    </h-form-layout>\n" +
    "</div>\n" +
    "");
}]);
